import React, { FC } from "react";
import { MDSText, MDSTextVariant } from "@/mds";
import styled from "@emotion/styled";

interface SettingsSubsectionTitleProps {
  title: React.ReactNode;
  className?: string;
}

export const SettingsSubsectionTitle: FC<SettingsSubsectionTitleProps> = ({ title }) => {
  return <StyledTitle variant={MDSTextVariant.HeaderL}>{title}</StyledTitle>;
};

const StyledTitle = styled(MDSText)`
  user-select: none;
  display: flex;
  align-items: center;
  padding: ${({ theme }) => `${theme.spacing[2]} 0`};
`;
